export default "__VITE_ASSET__Dl3jvwaz__"